module.exports = __webpack_public_path__ + "img/icons-line.0c5e4e05.svg";